export const userInfoHandlerAction = user => ({
  type: "USER_INFO",
  payload: user
});
